var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.002C11.4696 17.002 10.9609 16.7912 10.5858 16.4162C10.2107 16.0411 10 15.5324 10 15.002C10 13.892 10.89 13.002 12 13.002C12.5304 13.002 13.0391 13.2127 13.4142 13.5877C13.7893 13.9628 14 14.4715 14 15.002C14 15.5324 13.7893 16.0411 13.4142 16.4162C13.0391 16.7912 12.5304 17.002 12 17.002ZM18 20.002V10.002H6V20.002H18ZM18 8.00195C18.5304 8.00195 19.0391 8.21267 19.4142 8.58774C19.7893 8.96281 20 9.47152 20 10.002V20.002C20 20.5324 19.7893 21.0411 19.4142 21.4162C19.0391 21.7912 18.5304 22.002 18 22.002H6C5.46957 22.002 4.96086 21.7912 4.58579 21.4162C4.21071 21.0411 4 20.5324 4 20.002V10.002C4 8.89195 4.89 8.00195 6 8.00195H7V6.00195C7 4.67587 7.52678 3.4041 8.46447 2.46642C9.40215 1.52874 10.6739 1.00195 12 1.00195C12.6566 1.00195 13.3068 1.13128 13.9134 1.38256C14.52 1.63383 15.0712 2.00213 15.5355 2.46642C15.9998 2.93071 16.3681 3.48191 16.6194 4.08854C16.8707 4.69516 17 5.34534 17 6.00195V8.00195H18ZM12 3.00195C11.2044 3.00195 10.4413 3.31802 9.87868 3.88063C9.31607 4.44324 9 5.2063 9 6.00195V8.00195H15V6.00195C15 5.2063 14.6839 4.44324 14.1213 3.88063C13.5587 3.31802 12.7956 3.00195 12 3.00195Z",
    fill: "#36D66B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a54d8c93f5b78ad32d258277a0de21ee.svg";
export { ForwardRef as ReactComponent };